const STORE_CATALOGUE_SELECTOR = '.k-store-catalogue';

function enforceStoreGridDefault() {
  const catalogues = document.querySelectorAll(STORE_CATALOGUE_SELECTOR);
  if (!catalogues.length) return;

  for (const catalogue of catalogues) {
    const grid = catalogue.querySelector('.product-grid');
    if (grid && grid.getAttribute('product-grid-view') !== 'default') {
      grid.setAttribute('product-grid-view', 'default');
    }
  }
}

enforceStoreGridDefault();

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'childList' || mutation.attributeName === 'product-grid-view') {
      enforceStoreGridDefault();
      return;
    }
  }
});

observer.observe(document.documentElement, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['product-grid-view'],
});

document.addEventListener('shopify:section:load', enforceStoreGridDefault);
